import { bearerFetcher, useAuthBearerFetch } from "matsuri-hooks"
import { Operation } from "@/domain/operation"
import { m2mCleaning_managerV4 } from "@/endpoints/m2m-cleaning.manager-v4"

export const useOperation = (
    token: string,
    operationId: string | undefined
) => {
    return useAuthBearerFetch<Operation>(
        token,
        operationId
            ? m2mCleaning_managerV4.findOperationById({ operationId })
            : null,
        {}
    )
}

export const requestGetOperation = (token: string, operationId: string) => {
    const endpoint = m2mCleaning_managerV4.findOperationById

    return bearerFetcher<Operation>(token, endpoint({ operationId }), {
        method: endpoint.method
    })
}
